import { render, staticRenderFns } from "./StudentManage.vue?vue&type=template&id=f9c05582&scoped=true&"
import script from "./StudentManage.vue?vue&type=script&lang=js&"
export * from "./StudentManage.vue?vue&type=script&lang=js&"
import style0 from "./StudentManage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./StudentManage.vue?vue&type=style&index=1&id=f9c05582&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c05582",
  null
  
)

export default component.exports